import { LoadableActionFactory } from '../../../../shared/utils/redux/loadable/loadable.actions'
import { JsonTimeSeriesHeader } from '../../models/jsonTimeSeriesHeader.model'

export class TimeseriesActions {
  public static loadHeader = new LoadableActionFactory<
    void,
    JsonTimeSeriesHeader
  >('[COLUMN VISUALIZATION] LOAD HEADER TIMESERIES')
}
